import { MoleculeCoIcon } from './MoleculeCoIcon';

/**
 * author: Michael Irigoyen
 * id F3FDFD25-C4F6-4ECF-8F8B-C460E4C6BD7C
 * name molecule-co
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/molecule-co.svg
 * tags
 * - Home Automation 
 * - Science 
 */
export const GasCoIcon = MoleculeCoIcon;
export default GasCoIcon